"use client";

import dynamic from "next/dynamic";

import type { OmniboxSlidesProps } from "./OmniboxSlides";

const OmniboxSlides = dynamic(() => import("./OmniboxSlides"));

export default function OmniboxSlidesWrapper(props: OmniboxSlidesProps) {
  return <OmniboxSlides {...props} />;
}
